import api from './axiosService';

export const userActivityApi = {
    getAll(params = {}) {
        return api.get('/user-activities', { params });
    },

    getStats(params = {}) {
        return api.get('/user-activities/stats', { params });
    },

    getByUser(userlogId, params = {}) {
        return api.get(`/user-activities/by-log/${userlogId}`, { params });
    },

    getBySubject(subjectId, params = {}) {
        return api.get(`/user-activities/subject/${subjectId}`, { params });
    },

    getById(activityId) {
        return api.get(`/user-activities/${activityId}`);
    },
};